import React, { useState } from "react";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { resetpass } from "../utilities/userauth";
import { useNavigate } from "react-router-dom";
export const ResetPage = () => {
  const navigate = useNavigate;
  const initialField = {
    email: "",
    pin: "",
    password: "",
  };
  const [field, resetefield] = useState(initialField);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    resetefield({ ...field, [name]: value });
  };

  const Submithandler = async (e) => {
    e.preventDefault();
    const res = await resetpass({
      email: field.email,
      pin: field.otp,
      newpassword: field.password,
    });
    navigate("/");
  };

  return (
    <Container>
      <Row>
        <Col>
          <h3>Reset Password Page</h3>
          <hr />
          <Form onSubmit={Submithandler}>
            <Form.Group>
              <Form.Label>email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={field.email}
                placeholder="email"
                onChange={handleOnChange}
              />
              <Form.Label>OTP</Form.Label>
              <Form.Control
                type="otp"
                name="otp"
                value={field.otp}
                placeholder="otp"
                onChange={handleOnChange}
              />
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={field.password}
                placeholder="New password"
                onChange={handleOnChange}
              />
              <Button type="submit" className="mt-2">
                Submit
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  );
};
